import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-inform-modal',
  templateUrl: './inform-modal.component.html',
  styleUrls: ['./inform-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BaseModalComponent, TranslatePipe],
})
export class InformModalComponent {
  @Input() headline!: string;
  @Input() message!: string;
  @Input() actionLabel?: string;

  @Output() requestAction = new EventEmitter();

  triggerAction() {
    this.requestAction.emit();
  }
}
